export const ENABLED = 'ENABLED';
export const DISABLED = 'DISABLED';
export const ERROR = 'ERROR';